import { ConfigProvider, theme } from "antd";
import { createContext, useContext, useEffect, useState } from "react";
import fa_IR from "antd/lib/locale/fa_IR";
const ThemeContext = createContext();
export const ThemeContextProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [rtlMode, setRtlMode] = useState(true);
  const [cookies] = useState(["darkMode", "rtlMode"]);

  // useEffect(() => {
  //   const savedDarkMode = cookies.darkMode === "true";
  //   const savedRtlMode = cookies.rtlMode === "true";
  //   setDarkMode(savedDarkMode);
  //   setRtlMode(savedRtlMode);
  // }, []);

  // useEffect(() => {
  //   setCookie("darkMode", darkMode.toString(), { path: "/" });
  // }, [darkMode]);
  // useEffect(() => {
  //   setCookie("rtlMode", rtlMode.toString(), { path: "/" });
  // }, [rtlMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode, rtlMode, setRtlMode }}>
      <ConfigProvider
        locale={fa_IR}
        theme={{
          token: {
            fontFamily: rtlMode ? "IRANSansX" : "Roboto",
            fontFeatureSettings: "ss03",
          },
        }}
        direction={rtlMode ? "rtl" : "ltr"}
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
export function useTheme() {
  return useContext(ThemeContext);
}
